<template>
  <md-card>
    <!-- <md-card-header class="md-card-header-icon">
      <div class="card-icon">
        <md-icon>design_services</md-icon>
      </div>
      <h4 class="title">
        Item PO
      </h4>
    </md-card-header> --> 
    <md-card-content>
      <div class="md-layout">
        <div  class="md-layout-item md-size-50 md-small-size-100" style="margin-top:10px;">
          <validation-provider  rules="item" ref="procurement_order_dealer" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label class="label" >Part Dealer</label>
            <!-- <md-select  :disabled="page_type=='edit' && (procurement_order.procurement_order_status != 0)"  v-model="procurement_order_dealer_id" @md-selected="onChangeDealer()" > -->
              <md-select  :disabled="page_type=='edit' && (procurement_order.procurement_order_status != 0)"  v-model="procurement_order_dealer_id"  >
              <md-option   v-for="option in options_dealer_list" :key="option.value" :value="option.id">
                {{ option.dealer_name }}
              </md-option>
            </md-select>
            <validation-error :errors="apiValidationErrors.procurement_order_dealer_id" />
            <span class="md-error">{{ errors[0] }}</span>
              
            <!-- <validation-error :errors="apiValidationErrors.service_master_category_id" /> -->
          </md-field>
          </validation-provider>
        </div>
      </div>
      <br>
      <br>
      <div>
        <autoextra :collection="item" v-slot="{item,last,index}" >
          <div v-if="page_type=='add' || (page_type=='edit' && (procurement_order.procurement_order_status == 0 || procurement_order.procurement_order_status != 0 && !last) )" class="columns" :class="{last: last}">
            <!-- <div class="field column">
              <div class="control">
                <label class="label">{{last ? 'New ' : ''}}Person {{!last ? index + 1 : ''}}</label>
                <input class="input" type="text" v-model="item.name"/>
              </div>
              </div>
              <div class="field column">
                <label class="label">Age</label>
                <div class="control">
                  <input class="input" type="text" v-on:keypress="NumbersOnly" v-model="item.age"/>
                </div>
              </div> -->
              <div class="header" style="font-weight:bold; text-align:center; margin-bottom:20px; font-size:20px;">
                <label  class="label">{{last ? 'New ' : ''}}Item {{!last ? index + 1 : ''}}</label>
              </div>
              <div  class="md-layout">
                  <!-- <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Service Name</label>
                      <md-input   v-model="item.name" @click="check(index)"  />
                            
                    </md-field>
                  </div> -->
                  <input v-model="item.id" :readonly="true" type="hidden"/>
                  <!-- <div class="md-layout-item md-size-20 md-small-size-100">
                    <validation-provider rules="item" ref="procurement_order_item" v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label class="label" >Item Name</label>
                        <md-select :disabled="procurement_order_dealer_id == null || (page_type=='edit' && (procurement_order.procurement_order_status != 0))" v-model="item.price_item_id" @md-selected="onChangeItem(index, $event)"  @focus="focusSelectChanged(index) " >
                          <md-option v-for="option in options_item_list" :key="option.value" :value="option.id">
                            {{ '('+option.spare_part_price_part_master_code+') '+option.spare_part_price_part_master_name }}
                          </md-option>
                          
                        
                        </md-select>
                        <validation-error :errors="apiValidationErrors.price_item_id" />
                        
                        <span class="md-error">{{ errors[0] }}</span> 
                      </md-field>
                    </validation-provider>
                  </div> -->

                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <validation-provider rules="item" ref="procurement_order_item" v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label class="label" >Item Name</label>
                        <md-input  v-model="item.item_name" disabled/>
                          <md-button :disabled="procurement_order_dealer_id == null || (page_type=='edit' && (procurement_order.procurement_order_status != 0))" style="background-color:green;" class="md-icon-button md-round md-info md-dense" v-on:click="findItem(index)" @focus="modalCloseListItem(index) ">
                          <md-icon >search</md-icon>
                        </md-button>
                        <validation-error :errors="apiValidationErrors.price_item_id" />
                        
                        <span class="md-error">{{ errors[0] }}</span> 
                      </md-field>
                    </validation-provider>
                  </div>

                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field >
                      <label class="label" >Item Code</label>
                      <md-input  v-model="item.code" :readonly="true"/>
                        
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Base Price</label>
                      <md-input  v-model="item.base_price"  :readonly="true"/>
                        
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Discount</label>
                      <md-input :readonly="item.price_item_id == null || (page_type=='edit' && (procurement_order.procurement_order_status != 0)) "  v-model="item.discount" @change="discountChange(index,item.discount)" type="text" v-on:keypress="NumbersOnly"/>
                      <md-icon>percent</md-icon>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Price</label>
                      <md-input  v-model="item.price" :readonly="true"/>
                        
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Price Jual</label>
                      <md-input  v-model="item.pricejual" :readonly="true"/>
                        
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Margin</label>
                      <md-input  v-model="item.margin" :readonly="true"/>
                        
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >MOQ</label>
                      <md-input :readonly="true"  v-model="item.moq" />
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Quantity</label>
                      <md-input :min='item.moq' :readonly="item.price_item_id == null || (page_type=='edit' && (procurement_order.procurement_order_status != 0)) "  v-model="item.qty" @change="qtyChange(index,item.qty)" type="number" v-on:keypress="NumbersOnly"/>
                      
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Total</label>
                      <md-input  v-model="item.total" :readonly="true"/>
                    </md-field>
                  </div>
                  
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Alert Price</label>
                      <md-input :readonly="true"  v-model="item.alert_price" />
                        
                    </md-field>
                  </div>
                        
                  <md-card-actions style="border:none;" v-if="page_type=='add' || (page_type=='edit' && (procurement_order.procurement_order_status == 0))">
                    <md-button class="md-button-icon md-danger md-dense" @click="deleteColumn(index)" v-if="item.qty ">
                      delete
                    </md-button>
                  </md-card-actions>
                      
                </div>
                <span >{{ item.lower_price }}</span>    
              </div>
            </autoextra>
        </div>

      <div class="md-layout md-glutter">
        <div class="md-layout-item md-small-size-100">
          <div class="md-layout-item">
            <md-field>
              <label for="total-wo-tax">Total w/o Tax</label>
              <md-input  v-model="total_wo_tax" name="total-wo-tax" id="total-wo-tax" :readonly="true" />
            </md-field>
          </div>
        </div>
        <div class="md-layout-item md-small-size-100" v-if="tax == 'Yes'" >
          <div class="md-layout-item">
            <md-field>
              <label for="tax_total">Tax</label>
              <md-input  v-model="tax_total" name="tax_total" id="tax_total" :readonly="true" />
            </md-field>
          </div>
        </div>
        <div class="md-layout-item md-small-size-100">
          <div class="md-layout-item">
            <md-field>
              <label for="total">Total</label>
              <md-input  v-model="total" name="total" id="total" :readonly="true" />
            </md-field>
          </div>
        </div>
      </div>

    </md-card-content>
    <modal ref="modalListItem" class="coba">
      <!-- <template v-slot:header>
        <h3>List Item</h3>
      </template> -->
        
      <template v-slot:body>
        <list-item :data_id="$refs.modalListItem.data"/>
      </template>
    </modal>
  </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';
import {extend} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { Modal } from "@/components";
import ListItem from "@/pages/Dashboard/Workshop/ProcurementOrder/Modal/ListItem.vue";



// validasi pesan error required field
extend('dealer', {
  ...required,
  message: 'Dealer is required'
});
extend('item', {
  ...required,
  message: 'Item is required'
});

export default {
  name: "item-card",

  // props: {
  //   service_estimate: null,
  // },
  props: ['procurement_order'],
  components: { Autoextra, ValidationError, Modal, "list-item":ListItem },

  mixins: [formMixin],

  data () {
    return {
      item: [], 
      options_dealer_list: null,
      options_item_list: null,
      tax: null,
      procurement_order_dealer_id: null,
      total_wo_tax: null,
      tax_total: null,
      total: null,
      margin : null,
      isHidden: true,
      page_type: "add",
      item_name: null

    }
  },
  watch: {
    item: function (newVal) {
      //Deteksi perubahan di part untuk di kirim ke parent
      // this.$emit('data', newVal)
      //console.log(newVal)
      this.total_wo_tax = newVal.reduce( function(cnt,o){ return cnt + o.total; }, 0)
      if(this.tax == "Yes"){
        this.tax_total = newVal.reduce( function(cnt,o){ return cnt + o.total; }, 0) * 0.1 
      }
      this.total = this.tax_total +  this.total_wo_tax
        
    }

  },
  
  created() {
          this.onOpen();
      },
   methods:{
     async onOpen(){
       //ambil list data part dealer
       await this.$store.dispatch("workshop_part_dealer/list")
       this.options_dealer_list = await this.$store.getters["workshop_part_dealer/list"]

       //check router name 
       if(this.$route.name == "Edit Procurement Order"){
         //jika router name edit ganti nilai page_type menjadi edit, default nilainya add
          this.page_type = "edit"
        }
      
      },

      findItem(index){
        this.$refs.modalListItem.openModal({dealer_id: this.procurement_order_dealer_id,index: index})
      },

      modalCloseListItem(data, index){
        // console.log('index '+index);
        // console.log(data)
        // console.log(data.spare_part_price_lower_price[0].id)
        // console.log(data.id)

        

        if(data.id){

          var lower_price_notice = ""
          //check apakah id item dealer merupakan harga sparepart termuarah
          // if(parseInt(data.spare_part_price_lower_price[0] && data.spare_part_price_lower_price[0].id) !== parseInt(data.id)){
          //  //jika buka ini dengan informasi dealer mana yang itemnya termuarah
          //  lower_price_notice = "untuk item ini di dealer part "+data.spare_part_price_lower_price[0].part_dealers.dealer_name+" lebih murah dengan harga "+ data.spare_part_price_lower_price[0].spare_part_price_price
          // }

          this.$set(this.item, index, {
            id : null,
                price_item_id : data.id,
                master_item_id : data.spare_part_price_master_id,
                item_name : data.spare_part_price_part_master_name,
                code : data.spare_part_price_part_master_code,
                base_price : data.spare_part_price_price,
                discount : 0,
                price : data.spare_part_price_price,
                pricejual : data.spare_part_price_part_master_unit_price,
                margin : data.spare_part_price_price - data.spare_part_price_part_master_unit_price,
                qty : data.spare_part_price_minimum_order_quantity,
                total : data.spare_part_price_price * data.spare_part_price_minimum_order_quantity,
                moq : data.spare_part_price_minimum_order_quantity,
                alert_price : data.spare_part_price_part_master_alert_price,
                lower_price : lower_price_notice
          });


            // pko_driver_kip_no_text : data.driver_no
            this.$refs.modalListItem.closeModal()
            console.log(this.item)
          }
        

      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    
      //fungsi ketika ada perubahan di input select dealer
      // async onChangeDealer() {
      //   this.item = []
      //   // ambil list harga item berdasarka dealer yang dipilih
      //    await this.$store.dispatch("workshop_spare_part_price/list_price_dealer_id",this.procurement_order_dealer_id)
      //    this.options_item_list = await this.$store.getters["workshop_spare_part_price/list"]
      //    //cari nomor index dari object/array dealer list
      //    var indexOption = this.options_dealer_list.findIndex(p => p.id == this.procurement_order_dealer_id)
      //    //ambil nilai tax, untuk menentukan apakah dealer tsbt menggunakan ppn atau tidak
      //    this.tax = this.options_dealer_list[indexOption].dealer_use_ppn
      // },
      // check(index){
      //   console.log(index);
      //   //update by index
      // },
      //fungsi untuk delete column
      deleteColumn(index){
        if (index > -1) {
           this.item.splice(index, 1)
           var filtered = this.item.filter(function (el) {
            return el != null;
          });
          this.item = filtered;
          //this.$delete(this.part, index,1)
        }
        
      },
      //fungsi ketika ada perubahan focus di slect input part
      focusSelectChangeda(index){
        //check apakah ada nilai di item berdasarkan index part yang dipilih
        if(this.item[index]){
          //cari nomor index dari object/array dealer list
          var indexOption = this.options_item_list.findIndex(p => p.id == this.item[index].price_item_id)
          var lower_price=[]
              var lower_price_notice= null
              //for each options_item_list dari nomor index yang di dapat dari index item untuk mendapatkan
              //sparepart lower price
              this.options_item_list[indexOption].spare_part_price_lower_price.forEach((value, index) => {
                lower_price.push({dealer_id: value.part_dealers.id, dealer_name: value.part_dealers.dealer_name, price: value.spare_part_price_price});
              });
               console.log(lower_price)
              console.log(lower_price.find(o => o.dealer_id === parseInt(this.procurement_order_dealer_id)))
              //check apakah id item dealer merupakan harga sparepart termuarah
              if(lower_price.find(o => o.dealer_id === parseInt(this.procurement_order_dealer_id))){
                //jika iya, isi blank
                lower_price_notice = ""
              }
              else{
                //jika buka ini dengan informasi dealer mana yang itemnya termuarah
                let output = lower_price.map(data => data.dealer_name).join(', ')
                lower_price_notice = "Untuk item ini di dealer part "+output+" lebih murah dengan harga "+ lower_price[0]['price']
              }
              //set array untuk var item 
            this.$set(this.item, index, {
                id : null,
                price_item_id : this.item[index].price_item_id,
                code : this.options_item_list[indexOption].spare_part_price_part_master_code,
                base_price : this.options_item_list[indexOption].spare_part_price_price,
                discount : null,
                price : this.options_item_list[indexOption].spare_part_price_price,
                pricejual : this.options_item_list[indexOption].spare_part_price_part_master_unit_price,
                margin : this.options_item_list[indexOption].spare_part_price_part_master_unit_price - this.options_item_list[indexOption].spare_part_price_price ,
                qty : this.options_item_list[indexOption].spare_part_price_minimum_order_quantity,
                total : this.options_item_list[indexOption].spare_part_price_price * this.options_item_list[indexOption].spare_part_price_minimum_order_quantity,
                moq : this.options_item_list[indexOption].spare_part_price_minimum_order_quantity,
                alert_price : this.options_item_list[indexOption].spare_part_price_part_master_alert_price,
               lower_price : lower_price_notice
              });
          }
        
      },
      //fungsi ketika ada perubahan di slect input item part
      onChangeItem(index,event){
        //check apakah nilai event ada
        if(event){


              //cari nomor index dari data options_item_list erdasarkan id yang didapatkan dari event/id dari item
              var indexOption = this.options_item_list.findIndex(p => p.id == event)
              var lower_price=[]
              var lower_price_notice= null
              //for each options_item_list dari nomor index yang di dapat dari index item untuk mendapatkan
              //sparepart lower price
              this.options_item_list[indexOption].spare_part_price_lower_price.forEach((value, index) => {
                lower_price.push({dealer_id: value.part_dealers.id, dealer_name: value.part_dealers.dealer_name, price: value.spare_part_price_price});
              });
              //check apakah id item dealer merupakan harga sparepart termuarah
              if(lower_price.find(o => o.dealer_id === parseInt(this.procurement_order_dealer_id))){
                 //jika iya, isi blank
                lower_price_notice = ""
              }
              else{
                //jika buka ini dengan informasi dealer mana yang itemnya termuarah
                let output = lower_price.map(data => data.dealer_name).join(', ')
                lower_price_notice = "untuk item ini di dealer part "+output+" lebih murah dengan harga "+ lower_price[0]['price']
              }
              //check nilai item dengan nomor index ada
            if( this.item[index] && this.item[index].qty){
              //jika ada set array berdasarkan data dari item itu sendiri kecuali data lower price
                this.$set(this.item, index, {
                id : this.item[index].id,
                price_item_id : this.item[index].price_item_id,
                code : this.item[index].code,
                base_price : this.item[index].price,
                discount : null,
                price : this.item[index].price,
                pricejual : this.item[index].pricejual,
                margin : this.item[index].pricejual - this.item[index].price,
                qty : this.item[index].qty,
                total : this.item[index].price * this.item[index].qty,
                moq : this.item[index].moq,
                alert_price : this.item[index].alert_price,
                lower_price : lower_price_notice
              });
            }
            else{
              //jika tidak ada 
              console.log(this.options_item_list[indexOption].spare_part_price_minimum_order_quantity)
              //set data item dengan data dari options_item_list dengan indexoption yg di dapatkan sebelumnya
               this.$set(this.item, index, {
                id : null,
                price_item_id : event,
                code : this.options_item_list[indexOption].spare_part_price_part_master_code,
                base_price : this.options_item_list[indexOption].spare_part_price_price,
                discount : null,
                price : this.options_item_list[indexOption].spare_part_price_price,
                pricejual : this.options_item_list[indexOption].spare_part_price_part_master_unit_price,
                margin : this.options_item_list[indexOption].spare_part_price_part_master_unit_price - this.options_item_list[indexOption].spare_part_price_price,
                qty : this.options_item_list[indexOption].spare_part_price_minimum_order_quantity,
                total : this.options_item_list[indexOption].spare_part_price_price * this.options_item_list[indexOption].item_procurement_order_qty,
                moq : this.options_item_list[indexOption].spare_part_price_minimum_order_quantity,
                alert_price : this.options_item_list[indexOption].spare_part_price_part_master_alert_price,
                lower_price : lower_price_notice
              });
            }
          }
        },
        //fungsi ketika qty berubah
        qtyChange(index,qty){
          //check jika qty bukan null
          if(qty){

            
            
            if(this.item[index].discount != null){
              var price = this.item[index].base_price - (this.item[index].base_price * this.item[index].discount) / 100;
              var total = price * qty;
            }
            else{
              var price = this.item[index].base_price;
              var total = this.item[index].base_price * qty;
            }

         //set item berdasarkan index, kemudian isi dengan nilai item yang sama dengan perubahan di qty dan total 
          this.$set(this.item, index, {
                id : this.item[index].id,
                item_name :  this.item[index].item_name,
                price_item_id : this.item[index].price_item_id,
                master_item_id :  this.item[index].master_item_id,
                code : this.item[index].code,
                base_price : this.item[index].base_price,
                discount :  this.item[index].discount,
                price : price ,
                pricejual : this.item[index].pricejual,
                margin : this.item[index].pricejual - price,
                qty : qty,
                total : total,
                moq : this.item[index].moq,
                alert_price : this.item[index].alert_price,
                lower_price : this.item[index].lower_price
              });
            
            console.log("qtyChange");
          }

        },

        //fungsi ketika discount berubah
        discountChange(index,discount){
          //check jika qty bukan null
          

              if(discount != null && discount != 0){
                var price = this.item[index].base_price - (this.item[index].base_price * this.item[index].discount) / 100;
                var total = price * this.item[index].qty;
              }
              else{
                var price = this.item[index].base_price;
                var total = this.item[index].base_price * this.item[index].qty;
              }
              
            
         //set item berdasarkan index, kemudian isi dengan nilai item yang sama dengan perubahan di qty dan total 
          this.$set(this.item, index, {
                id : this.item[index].id,
                item_name :  this.item[index].item_name,
                price_item_id : this.item[index].price_item_id,
                master_item_id :  this.item[index].master_item_id,
                code : this.item[index].code,
                base_price : this.item[index].base_price,
                discount :  this.item[index].discount,
                price : price ,
                pricejual : this.item[index].pricejual,
                margin : this.item[index].pricejual - price,
                qty : this.item[index].qty,
                total : total,
                moq : this.item[index].moq,
                alert_price : this.item[index].alert_price,
                lower_price : this.item[index].lower_price
              });
            
            console.log("discountChange");
          

        },

        //ini fungsi yang di panggil di parent untuk mendapatkan data yang ada di sini
        getData() {
            this.$emit('data', {procurement_order_dealer_id: this.procurement_order_dealer_id, item: this.item})
        },

        // //ini fungsi yang di panggil di parent untuk mengirim data ke child ini dan set data, digunakan saat edit
        // async getDataParent() {
        //   //set page type to edit
        //   this.page_type = "edit"
        //   console.log (this.procurement_order)
        //   this.procurement_order_dealer_id = this.procurement_order.procurement_order_dealer_id
        //   //check apakah options_item_list null
        //   if(!this.options_item_list){
        //     //jika null ambil data list item  di api kembali berdasarkan dealer id
        //      await this.$store.dispatch("workshop_spare_part_price/list_price_dealer_id",this.procurement_order_dealer_id)
        //     this.options_item_list = await this.$store.getters["workshop_spare_part_price/list"]
        //   }
        //   console.log(this.options_item_list)

        //   //for each data procurement_order_item untuk di set di array item 
        //   this.procurement_order.procurement_order_item.forEach((value, index) => {
        //     //cari nomor index options_item_list bersarkan id item
        //     var indexOption = this.options_item_list.findIndex(p => p.id == value.item_procurement_order_price_id)
        //    //set array berdasarkan data yang ada di options_item_list berdasarkan indexoption
        //    this.$set(this.item, index, {

        //         id : value.id,
        //         price_item_id : value.item_procurement_order_price_id,
        //         code : this.options_item_list[indexOption].spare_part_price_part_master_code,
        //         base_price : data.spare_part_price_price,
        //         discount : 0,
        //         price : this.options_item_list[indexOption].spare_part_price_price,
        //         pricejual : this.options_item_list[indexOption].spare_part_price_part_master_unit_price,
        //         margin : this.options_item_list[indexOption].spare_part_price_part_master_unit_price - this.options_item_list[indexOption].spare_part_price_price,
        //         qty : value.item_procurement_order_qty,
        //         total : this.options_item_list[indexOption].spare_part_price_price * value.item_procurement_order_qty,
        //         moq : this.options_item_list[indexOption].spare_part_price_minimum_order_quantity,
        //         alert_price : this.options_item_list[indexOption].spare_part_price_part_master_alert_price

        //         });
        //   });
        // },


        //ini fungsi yang di panggil di parent untuk mengirim data ke child ini dan set data, digunakan saat edit
        async getDataParent() {
          //set page type to edit
          this.page_type = "edit"
          console.log (this.procurement_order)
          this.procurement_order_dealer_id = this.procurement_order.procurement_order_dealer_id

          //for each data procurement_order_item untuk di set di array item 
          this.procurement_order.procurement_order_item.forEach((value, index) => {

           //set array berdasarkan data yang ada di procurement_order_item
           this.$set(this.item, index, {

                id : value.id,
                master_item_id : value.item_procurement_item_id,
                price_item_id : value.item_procurement_order_price_id,
                item_name :  value.spare_part.spare_part_master_name,
                code : value.spare_part.spare_part_master_code,
                base_price : value.item_procurement_base_price,
                discount : value.item_procurement_discount,
                price : value.item_procurement_price,
                pricejual : value.spare_part.spare_part_master_unit_price,
                margin : value.spare_part.spare_part_master_unit_price - value.item_procurement_price,
                qty : value.item_procurement_order_qty,
                total : value.item_procurement_price * value.item_procurement_order_qty,
                moq : value.spare_part_price ? value.spare_part_price.spare_part_price_minimum_order_quantity:null,
                alert_price : value.spare_part_master_alert_price

                });
          });
        },

        //fungsi yang di panggil di parent untuk menegecheck apakah column input telah tersisi
      async validateForm() {
        const procurement_order_dealer = this.$refs['procurement_order_dealer'];
        const procurement_order_item = this.$refs['procurement_order_item'];
        let result = []
        result.push(
          await procurement_order_dealer.validate().then(function(data){
            return data.valid
          })
        ) 
        if(this.item.length == 0){
          result.push(
            await procurement_order_item.validate().then(function(data){
              return data.valid
            })
          )
        }
        return result.every(Boolean)
      },

 
      formatPrice(value) {
          let val = (value/1).toFixed().replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }, 
      
    }
  };
 
</script>

<style lang="scss" scoped>
.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}

.coba{
  width:950px !important;
  margin: 50px auto !important;
  height:700px !important;
  z-index: 9999 !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
